module.exports = {
    'Ball': require('./Ball.js'),
    'Paddle': require('./Paddle.js'),
};



// WEBPACK FOOTER //
// ./src/Objects/index.js